var map = {
	"./banner_jig.jpg": 6470,
	"./banner_jig_2.jpg": 1293,
	"./banner_talentpool.jpg": 9462,
	"./bbg/jobs_banner.jpg": 604,
	"./bbg/skilled_banner.jpg": 7020,
	"./bbg/slide-4.jpg": 41,
	"./bbg/welcome_banner.gif": 7491,
	"./coe/jobs_banner.jpg": 9440,
	"./coe/skilled_banner.jpg": 4960,
	"./coe/slide-4.jpg": 3869,
	"./coe/welcome_banner.jpg": 4772,
	"./edunetasia/jobs_banner.jpg": 4560,
	"./edunetasia/skilled_banner.jpg": 3968,
	"./edunetasia/slide-4.jpg": 4077,
	"./edunetasia/welcome_banner.jpg": 3188,
	"./edunetin/jobs_banner.jpg": 2059,
	"./edunetin/skilled_banner.jpg": 973,
	"./edunetin/slide-4.jpg": 5334,
	"./edunetin/welcome_banner.jpg": 6809,
	"./edunetke/jobs_banner.jpg": 5806,
	"./edunetke/skilled_banner.jpg": 1282,
	"./edunetke/slide-4.jpg": 827,
	"./edunetke/welcome_banner.jpg": 8901,
	"./edunetma/jobs_banner.jpg": 9736,
	"./edunetma/skilled_banner.jpg": 5528,
	"./edunetma/slide-4.jpg": 5445,
	"./edunetma/welcome_banner.jpg": 2780,
	"./en/jobs_banner.jpg": 2470,
	"./en/skilled_banner.jpg": 1418,
	"./en/slide-4.jpg": 467,
	"./en/welcome_banner.gif": 2605,
	"./en/welcome_logo.jpg": 5429,
	"./jobs_banner.jpg": 4378,
	"./kle/jobs_banner.jpg": 1549,
	"./kle/skilled_banner.jpg": 5451,
	"./kle/slide-4.jpg": 3768,
	"./kle/welcome_banner.gif": 6768,
	"./skilled_banner.jpg": 7934,
	"./slide-1.jpg": 7758,
	"./slide-2.jpg": 1465,
	"./slide-3.jpg": 6092,
	"./slide-4.jpg": 439,
	"./welcome_banner.jpg": 3342
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3721;